import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

common.View.create('initiatief::canvas.blocks.modules.initiatieven.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        const swiperElement = this.element.find('.initiatieven-swiper');

        if (swiperElement.length === 0) {
            return;
        }

        const nextButton = swiperElement.find('.swiper-button-next').get(0);
        const prevButton = swiperElement.find('.swiper-button-prev').get(0);

        new Swiper(swiperElement.get(0), {
            modules: [Navigation],
            loop: false,
            spaceBetween: 24,
            slidesPerView: 1.15,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.15,
                },
                1024: {
                    slidesPerView: 4.15,
                },
            },
        });
    },
});
